import { usePersistedChatState } from './useAppShellChatModel/usePersistedChatState'
import { useChatDerivedState } from './useAppShellChatModel/useChatDerivedState'

/**
 * Router-derived context + persisted chat model (threads, messages, rail).
 * No side-effects — sync hooks consume this shape.
 */
export function useAppShellChatModel() {
  const state = usePersistedChatState()
  const derived = useChatDerivedState(state)
  return { ...state, ...derived }
}
